import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/dashboard";
import AirframeTemplateUploadPage from "./pages/airframe-template-upload";
import BulkTemplateUploadPage from "./pages/bulk-template-upload";
import Admin from "./pages/admin";
import Document from "./pages/document";
import Upload from "./pages/documents/upload";
import Search from "./pages/documents/search";
import DocumentExports from "./pages/documents/exports";
import DocumentMoveJobsPage from "./pages/documents/move-jobs";
import DocumentViewer from "./components/documents/document-viewer";
import { ManageAirframes } from "./components/assets-management/airframes/components/ManageAirframes";
import Assets from "./pages/assets";
import { ManageComponents } from "./components/assets-management/components/components/ManageComponents";
import { ManageSubAssemblies } from "./components/assets-management/sub-assemblies/components/ManageSubAssemblies";
import { GuardedRoute } from "./components/common/guarded-route";
import UserAccess from "./pages/user-access";
import TenantManagement from "./pages/admin/tenant-management";
import BugReportListPage from "./pages/admin/bug-report-list";
import AuditLogPage from "./pages/audit-log";
import BugAttachmentViewerPage from "./pages/admin/bug-attachment-viewer";
import MiniPackTemplateViewerPage from "./pages/admin/mini-pack-template-viewer";
import TenantFeatureMapping from "./pages/on-boarding/tenant-feature-mapping";
import AuthLoadingPage from "./pages/authLoadingPage";
import NoAccessPage from "./pages/no-access";
import BugReportFormPage from "./pages/bug-report-form";
import TenantManagementPage from "./pages/tenant-management";
import MiniPackGeneratorPage from "./pages/assets/mini-pack-generator";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" />} />
      <Route path="/auth-loading" element={<AuthLoadingPage />} />
      <Route path="/no-access" element={<NoAccessPage />} />
      <Route path="/bug-report" element={<BugReportFormPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      
      {/* Admin routes - require accessmanagement read permission */}
      <Route 
        path="/admin" 
        element={<GuardedRoute feature="accessmanagement" element={<Admin />} />} 
      />
      <Route 
        path="/userAccess" 
        element={<GuardedRoute feature="accessmanagement" element={<UserAccess />} />} 
      />
      <Route 
        path="/access-management" 
        element={<GuardedRoute feature="accessmanagement" element={<UserAccess />} />} 
      />
      <Route
        path="/access-management/tenant-management"
        element={<GuardedRoute feature="accessmanagement" element={<TenantManagementPage />} />}
      />
      <Route
        path="/access-management/shop-visit-reasons"
        element={<Navigate to="/access-management/tenant-management" replace />}
      />
      <Route
        path="/app-management/bug-reports"
        element={<GuardedRoute feature="" element={<BugReportListPage />} />}
      />
      <Route
        path="/app-management/audit-logs"
        element={<GuardedRoute feature="" element={<AuditLogPage />} />}
      />
      <Route
        path="/bug-report/attachment/:id"
        element={<GuardedRoute feature="accessmanagement" element={<BugAttachmentViewerPage />} />}
      />
      <Route
        path="/access-management/mini-pack-template/:id"
        element={<GuardedRoute feature="accessmanagement" element={<MiniPackTemplateViewerPage />} />}
      />
      {/* Document hub/search: IATA search or NAS-only tenants. */}
      <Route 
        path="/document" 
        element={<GuardedRoute featureAny={["documents-search", "documents-nas"]} element={<Document />} />} 
      />
      {/* Search stays mounted for /document/search and /document/search/browse/* (nested).
          Viewer stays a sibling at /document/search/:id so folder URLs never open a document. */}
      <Route
        path="/document/search"
        element={<GuardedRoute featureAny={["documents-search", "documents-nas"]} element={<Search />} />}
      >
        <Route path="browse/*" element={null} />
      </Route>
      <Route 
        path="/document/search/:id" 
        element={<GuardedRoute feature="documents-search" element={<DocumentViewer />} />} 
      />
      <Route 
        path="/document/upload" 
        element={<GuardedRoute feature="documents-upload" element={<Upload />} />} 
      />
      <Route
        path="/document/exports"
        element={<GuardedRoute feature="documents-search" element={<DocumentExports />} />}
      />
      <Route
        path="/document/move-jobs"
        element={<GuardedRoute feature="documents-move" element={<DocumentMoveJobsPage />} />}
      />
      {/* Assets routes - require respective permissions */}
      <Route 
        path="/assets" 
        element={<GuardedRoute featureAny={["assets-assemblies", "assets-airframes", "assets-bulk-template-upload"]} element={<Assets />} />} 
      />
      <Route 
        path="/assets/manage-airframe" 
        element={<GuardedRoute feature="assets-airframes" element={<ManageAirframes />} />} 
      />
      <Route 
        path="/assets/manage-component" 
        element={<GuardedRoute feature="assets-assemblies" element={<ManageComponents />} />} 
      />
      <Route
        path="/assets/mini-pack-generator"
        element={<GuardedRoute feature="assets-mini-pack-export" element={<MiniPackGeneratorPage />} />}
            />
            <Route
        path="/assets/manage-sub-assembly"
        element={<GuardedRoute feature="assets-assemblies" element={<ManageSubAssemblies />} />}
      />
      <Route
        path="/assets/bulk-template-upload"
        element={<GuardedRoute feature="assets-bulk-template-upload" element={<BulkTemplateUploadPage />} />}
      />
      <Route
        path="/airframe-template-upload"
        element={<GuardedRoute requireGlobalAdmin element={<AirframeTemplateUploadPage />} />}
      />
      {/* Onboarding and tenant management routes - admin only */}
      <Route 
        path="/on-board/tenant-management" 
        element={<GuardedRoute feature="onboarding" element={<TenantManagement />} />} 
      />
      <Route 
        path="/on-board/tenant-feature-mapping" 
        element={<GuardedRoute feature="onboarding" element={<TenantFeatureMapping />} />} 
      />
    </Routes>
  );
     
};

export default AppRoutes;
